import { useFormContext } from 'react-hook-form'
import FuelInput from '@components/form/FuelInput'
import Error from '@components/form/validation/Error'
import styles from 'styles/SearchActionBar.module.css'
import inputStyles from 'styles/Input.module.css'
import useT from '@hooks/useTranslation'

const ContextFuelInput = ({ name, error,
    nolabel, ...rest }) => {

    const { register, setValue } = useFormContext()
    const inputName = name || 'paliwo'
    return <>
        {
            !nolabel && <>
                <br/>
                <label htmlFor={inputName}>
                    <span className={inputStyles.label_text} required={rest.required}>
                        { useT('Paliwo') }
                    </span>
                </label>
            </>
        }

        <div id={inputName} className={styles.action_bar} style={{ marginLeft: -18 }}>
            <div className={styles.fuels} style={{ border: 'none' }}>
                <FuelInput {...rest}
                    name={inputName}
                    register={register}
                    setValue={setValue} />
            </div>
        </div>
        { error && <Error name={inputName} /> }
    </>
}

export default ContextFuelInput